import { MyAccountSWR } from '@sky-tv-group/shared';
import { kkService, myAccountService } from './services';

export const myAccountSWR = new MyAccountSWR(myAccountService, kkService);
